import { all, fork } from 'redux-saga/effects'
import ProfileSaga from './profile/saga'

export default function* rootSaga() {
  yield all([
    fork(ProfileSaga)
  ]);
}